import { render, staticRenderFns } from "./FontSelect.vue?vue&type=template&id=313e4681&"
import script from "./FontSelect.vue?vue&type=script&lang=js&"
export * from "./FontSelect.vue?vue&type=script&lang=js&"
import style0 from "./FontSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VCombobox,VSelect})
